import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/locals.actions';
import * as home from '../../../../actions/process.home.actions';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';

import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';

import Local from '@material-ui/icons/LocalDining';
import { ExpandMenu, ContractMenu } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

class Locals extends React.Component {
    constructor(props) {
        super(props);
        props.all();
        this.state = {
            toShow: [],
        };
    }

    handleClick = (id) => {
        this.props.history.push(`ouichef/${id}`);
    };

    handleMenuBar = () => {
        this.props.setHideAppBar(!this.props.window.appbar);
    };

    static getDerivedStateFromProps(props, state) {
        if (props && props.locals && props.locals !== state.locals) {
            const permits = props.info.security.localPermits;

            const enabled = Object.keys(permits).reduce((arr, key) => {
                const p = permits[key];
                if (p.some((value) => value === '20' || value === '58')) {
                    arr.push(key);
                }
                return arr;
            }, []);
            const toShow = props.locals.reduce((arr, l) => {
                if (l.configurado === 3 && enabled.some((e) => e === l.id.toString())) {
                    arr.push(l);
                }
                return arr;
            }, []);
            state.locals = props.locals;
            state.toShow = toShow;

            if (toShow.length === 1) {
                props.history.push(`ouichef/${toShow[0].id}`);
            }

            return state;
        }
        return null;
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info, locals_is_loading, locals_has_errored, window } = this.props;
        const { toShow } = this.state;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '58')  &&
              info.security.licencias.some((f) => f.id === 154 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (locals_has_errored.hasErrored) {
            return <Error open type={locals_has_errored.hasErrored}  message={locals_has_errored.error} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {locals_is_loading && <Loading open opacity />}

                    <div className={'display_flex width100 center'}>
                        <Grid container justify="center">
                            {toShow &&
                                toShow.length > 0 &&
                                toShow
                                    .sort((a, b) =>
                                        a.ruta.toUpperCase().trim() < b.ruta.toUpperCase().trim()
                                            ? -1
                                            : a.ruta.toUpperCase().trim() > b.ruta.toUpperCase().trim()
                                            ? 1
                                            : a.nombre.toUpperCase().trim() <
                                            b.nombre.toUpperCase().trim()
                                            ? -1
                                            : 1,
                                    )
                                    .map((local, index) => (
                                        <Grid key={`local-${index}`}
                                            item xs={2}
                                            onClick={(event) => this.handleClick(local.id)}
                                            className="flex_auto_column size_buttom hand center padding_borders roundedBox text_wrap margin_left_12 margin_top_12">
                                            <Local
                                                className={'c_bluish margin_bottom_12'}
                                                fontSize="large"
                                            />
                                            <span
                                                className={
                                                    'c_bluish margin_bottom_12 barlow_semibold uppercase'
                                                }
                                            >
                                                {local.nombre}
                                            </span>
                                        </Grid>
                                    ))}
                        </Grid>
                        
                    </div>
                    <Fab
                        aria-label="add"
                        className={'button_float_left bg_white'}
                        onClick={this.handleMenuBar}
                    >
                        {!window.appbar ? (
                            <ExpandMenu color="primary" />
                        ) : (
                            <ContractMenu color="primary" />
                        )}
                    </Fab>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        locals: state.locals,
        locals_is_loading: state.locals_is_loading,
        locals_has_errored: state.locals_has_errored,
        info: state.info,
        window: state.window,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Locals));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/fast/Index.js